import { t } from 'i18next';

export const dutControlOperation = [
  { label: t('desligar'), value: '0_DESLIGAR' },
  { label: t('refrigerar'), value: '1_REFRIGERAR' },
  { label: t('ventilacao'), value: '2_VENTILAR' },
  { label: t('modoSobDemanda'), value: '3_SOB_DEMANDA' },
  { label: t('modoEco'), value: '4_ECO' },
  { label: t('modoLimitador'), value: '5_LIMITADOR' },
];
